<template>
    <div class="gallery-wrap">
        <div class="gallery-bigger">
            <img :src="selectedImage">
        </div>
        <div class="gallery-thumbnails">
            <div class="gallery-scrolling-btn left-scrolling" @click="leftScrolling">
                <span class="fas fa-chevron-left"></span>
            </div>
            <div class="gallery-content-wrap">
                <div class="gallery-thumbnails-content">
                    <div class="gallery-thumbnail-item" v-for="(i, image) in images" :key="i" style="{{ i == 0 ? 'active' : '' }}" @click="selectImage(image, i)">
                        <img :src="image">
                    </div>
                </div>
            </div>
            <div class="gallery-scrolling-btn right-scrolling" @click="rightScrolling">
                <span class="fas fa-chevron-right"></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'gallery',
    props: {
        images: Array,
        selectedImage: String
    },
    data: function () {
        return {
            selectedImage: this.images[0]
        }
    },
    methods: {
        selectImage: function(newUrl, i) {
            let carouselContent = document.querySelector('.gallery-thumbnails-content');
            this.selectedImage = newUrl;
            try { Array.from(carouselContent.children).find(item => item.classList.contains('active')).classList.remove('active'); } catch(err) {}
            carouselContent.children[i].classList.add('active');
        },
        leftScrolling: function() {
            let carouselContent = document.querySelector('.gallery-content-wrap');
            carouselContent.scroll({
                left: carouselContent.scrollLeft - (carouselContent.offsetWidth / 2),
                behavior: 'smooth'
            });
        },
        rightScrolling: function() {
            let carouselContent = document.querySelector('.gallery-content-wrap');
            carouselContent.scroll({
                left: carouselContent.scrollLeft + (carouselContent.offsetWidth / 2),
                behavior: 'smooth'
            });
        }
    }
}
</script>

<style scoped>
    .gallery-bigger {
      border: 1px solid #ddd;
      border-radius: 2px;
      background-color: #fff;
      text-align: center;
      padding: 40px;
    }

    .gallery-bigger * {
        -webkit-transition: all .3s;
        transition: all .3s;
    }

    .gallery-bigger img {
        max-width: 100%;
        height: auto;
    }

    .gallery-thumbnails {
        display: flex;
        height: 90px;
        overflow: hidden;
        margin: 20px 0;
        position: relative;
        overflow-x: auto;
    }

    .gallery-scrolling-btn {
        min-width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 25px;
        color: rgba(0,0,0,.1);
        position: absolute;
        cursor: pointer;
        height: 100%;
    }

    .gallery-scrolling-btn:hover {
        color: rgba(0,0,0,.6);
        background-color: rgba(255,255,255,.4);
    }

    .gallery-scrolling-btn.right-scrolling {
        right: 0;
    }

    .gallery-content-wrap {
            width: 100%;
    display: flex;
    overflow: hidden;
    overflow-x: auto;
    }

    .gallery-content-wrap::-webkit-scrollbar {
        display: none;
    }

    .gallery-thumbnails-content {
        display: flex;
        flex-flow: row;
        align-items: center;
    }

.gallery-thumbnail-item {
    width: 95px;
    height: 85px;
    background-color: #fff;
    border: 1px solid #ccc;
    margin-right: 20px;
    overflow: hidden;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.gallery-thumbnail-item.active {
    border-width: 5px;
}

.gallery-thumbnail-item img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
}
</style>


// WEBPACK FOOTER //
// regular-gallery.vue?08e97f98